export const UserTypes = {
    OS_USER: 'O',
    OS_USER_WITHOUT_PUBLIC_KEY: 'OS_USER_WITHOUT_PUBLIC_KEY',
    OS_USER_WITHOUT_PRIVATE_KEY: 'OS_USER_WITHOUT_PRIVATE_KEY',
    OS_USER_WITHOUT_OLD_PRIVATE_KEY: 'OS_USER_WITHOUT_OLD_PRIVATE_KEY',
    REGISTER_USER: 'R',
    REGISTER_USER_WITHOUT_PUBLIC_KEY: 'REGISTER_USER_WITHOUT_PUBLIC_KEY',
    REGISTER_USER_WITHOUT_PRIVATE_KEY: 'REGISTER_USER_WITHOUT_PRIVATE_KEY',
    USER: 'U', // Is the basic user created at registrar sign up,
    A_AUDITOR: 'A', // BACK Changed and now sends this type, not sure what it signifies
    AUDITOR_WITHOUT_PUBLIC_KEY: 'AUDITOR_WITHOUT_PUBLIC_KEY',
    AUDITOR_WITHOUT_PRIVATE_KEY: 'AUDITOR_WITHOUT_PRIVATE_KEY',
    AUDITOR_WITHOUT_OLD_PRIVATE_KEY: 'AUDITOR_WITHOUT_OLD_PRIVATE_KEY',
    AUDITOR: 'AUDITOR',
    ROCHE_USER: 'RO',
    ROCHE_USER_WITHOUT_PRIVATE_KEY: 'ROCHE_USER_WITHOUT_PRIVATE_KEY',
    DRUGSTORE: 'D',
    DRUGSTORE_WITHOUT_PUBLIC_KEY: 'D_WITHOUT_PUBLIC_KEY',
    DRUGSTORE_WITHOUT_PRIVATE_KEY: 'D_WITHOUT_PRIVATE_KEY',
    DRUGSTORE_WITHOUT_OLD_PRIVATE_KEY: 'D_WITHOUT_OLD_PRIVATE_KEY',
};

export const UserTypesGroups = {
    OS_USER_GROUP: 'OS_USER_GROUP',
    AUDIT_USER_GROUP: 'AUDIT_USER_GROUP',
    DRUGSTORE_USER_GROUP: 'DRUGSTORE_USER_GROUP',
};

export const TRACE_DEFAULT_LENGTH = 50;

export const TRANSACTION_STATUS = {
    PENDING: 'P',
    REJECTED: 'R',
    VALIDATED: 'V',
    VALIDATION_ERROR: 'E',
    PAID: 'G',
    POSTED: 'C',
    PROCESSING_PAYMENT: 'O',
    INTERFACE_ERROR_SAP: 'I',
    FUTURE_EVIDENCE_PENDING: 'F',
};

export const VOLUME_CONTRACT_TYPE_ID = 8;

// Adelanto NEX — TipoContrato id 9, letter 'V' (same as Volumen tradicional id 8).
// Distinguish Adelanto by id, not by tipo_contrato_tipo. Monitor UI uses internal
// tipo_proceso 'C' only for row labelling — not a DB value.
export const ADELANTO_CONTRACT_TYPE_ID = 9;
export const ADELANTO_CONTRACT_TYPE_LETTER = 'V';

export const VOLUME_TRANSACTION_STATUS = {
    PENDING: 'P',
    REJECTED: 'R',
    VALIDATED: 'V',
    PAID: 'G',
    PROCESSING_PAYMENT: 'O',
    INTERFACE_ERROR_SAP: 'I',
};

// Adelanto NEX UI badge state for a contract version's advance.
// Distinct from ESTADO_TOKEN (TransaccionesToken) and from
// VOLUME_TRANSACTION_STATUS — this models the "cupo" lifecycle as shown
// on FR-05 badges. Single-letter codes follow the project convention
// (first letter of the Spanish term). Backend BA-10 will expose the
// Compact UI codes derived from adelanto_nex.estado_cupo (contract badges).
// Monitor estado cupo uses ADELANTO_CUPO_ESTADO strings from the backend directly.
export const ADELANTO_TRANSACTION_STATUS = {
    NOT_SENT: 'N', // No enviado — version exists, advance not yet emitted
    SENT: 'E', // Enviado — cupo PENDIENTE (nothing registered yet)
    PARTIAL: 'P', // Parcialmente rendido — estado_cupo PARCIAL
    COMPLETED: 'R', // Rendido — estado_cupo COMPLETO
    EXCEEDED: 'X', // Excedido — estado_cupo EXCEDIDO
};

export const MONITOR_TRANSACTION_STATUS = {
    PREPARED: 'P',
    SENDING: 'S',
    RECEIVED: 'R',
    SENT: 'E',
    ERROR: 'F',
    UNKNOWN: 'U',
};

export const InstitutionTypes = {
    PHARMACY: 'F',
    INFUSION_CENTER: 'I',
    OTHERS: 'O',
    TAKE_CARE_OR_PATIENT: 'C',
};

export const RocheTransactionDownloadType = {
    ALL: 'ALL',
    EMITTED: 'EMITTED',
    RECEIVED: 'RECEIVED',
};

export const NexTransactionsOriginsAndDestinations = {
    OS: 'O',
    DRUGSTORE: 'D',
    ROCHE: 'R',
};

export const AssetsRefs = {
    NEX: '173752-301-9620',
};
